<template>
    <div>
        <div class="knd-handleiding knd-wrapper knd-m-auto knd-my-5">
            <div class="" v-html="content.tekst"></div>
        </div>
    </div>
</template>

<script>
    import enterView from 'enter-view';

    export default {
        props: {
            content: {
                type: Object
            }
        },
        mounted () {
            this.setEnterView();
        },

        methods: {
            setEnterView() {
                enterView({
                selector: '.knd-handleiding p',
                enter: async (el) => {
                    el.classList.add('entered');
                },
                exit: function(el) {
                    el.classList.remove('entered');
                },
                offset: 0.2, // enter at middle of viewport
                once: true, // trigger just once
                });
            }
        },

    }
</script>

<style lang="scss" >
    .knd-handleiding {
        p {
            opacity: 0;
            background: theme('colors.red.light');
            padding: 2rem;
            border-radius: 0.375rem;
            position: relative;

            transition: opacity .4s ease-in;

            &.entered {
                opacity: 1;
            }

            &:before {
                    content: '';
                    border-right: 2px dashed theme('colors.red.light');;
                    height: 98%;
                    left: 50%;
                    transform: translateX(-50%);
                    position: absolute;
                    top: -50px;
                    z-index: -1;
                }            

            &:first-of-type {
                position: relative;
                margin-top: 35px;
                &:before {
                    content:url('~@/assets/icons/archief_icon.png');
                    border: none;
                    background-repeat: no-repeat;
                    background-size: contain;
                    position: absolute;
                    z-index: 1;
                    left: 50%;
                    top: -35px;
                    transform: translateX(-50%);
                }

                &:after {
                    content: 'handleiding';
                    border: none;
                    position: absolute;
                    z-index: 1;
                    right: 10px;
                    bottom: 5px;
                    font-size: 1.2rem;
                    text-transform: uppercase;
                    color: #FFF;
                }                
            }
        }
    }
</style>